/** @jsxImportSource @emotion/react */
import { StyleSheet, View } from "@react-pdf/renderer";
import { PDFLayerMeta } from "./PDFLayerMeta";

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        flexGrow: 1,
        marginTop: 20
    },
    cell1: {
        width: "35%", // Adjust based on your layout
    },
    cell2: {
        width: "63%", // Adjust based on your layout
    },
});

export const PDFTwoColumnMetaLayout = ({
    layer_fields,
    general_status = undefined,
    pdf_config,
    children
}) => {
    return (
        <View style={styles.row} wrap={false}>
            <View style={styles.cell1}>
                <PDFLayerMeta fields={layer_fields} status={general_status} categories={pdf_config.categories} />
            </View>

            <View style={styles.cell2}>
                {children}
            </View>
        </View>
    );
};
